import React from 'react';
import styled from 'styled-components';

import { translate, nf } from '~/utils';

import ChartLabel from './ChartLabel';

const Tick = styled.g`
  transition: transform 0.5s;
`;

const GridLine = styled.line`
  stroke: ${(p) => (p.dashed ? '#ddd' : p.theme.colors.greyblue)};
  stroke-width: ${(p) => (p.dashed ? 1 : 1)};
  stroke-dasharray: ${(p) => (p.dashed ? '2 2' : 'none')};
  shape-rendering: crispEdges;
`;

const YAxisLabel = styled(ChartLabel)`
  text-anchor: start;
`;

const XAxisLabel = styled(ChartLabel)``;

const XAxisDescription = styled(ChartLabel)`
  font-size: 1.05em;
`;

const Grid = ({
  xScale,
  yScale,
  width,
  height,
  isRelView,
  xAxisLabel = '',
  yAxisLabel = '',
  isZoomView,
}) => {
  const xTicks = isZoomView
    ? xScale.ticks(3)
    : [1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  const yTicks = yScale.ticks(5);
  const yFormat = isRelView ? '.0f' : ',';

  return (
    <g>
      {xTicks.map((tick) => (
        <Tick transform={translate(xScale(tick), 0)} key={tick}>
          <XAxisLabel y={height + 20}>{nf(tick, yFormat)}</XAxisLabel>
          <GridLine x1={0} x2={0} y1={0} y2={height} dashed />
        </Tick>
      ))}

      {yTicks.map((tick) => (
        <Tick transform={translate(0, yScale(tick))} key={tick}>
          <YAxisLabel x={5} y={3} transform={translate(width, 0)}>
            {nf(isRelView ? tick * 100 : tick, yFormat)}
          </YAxisLabel>
          <GridLine x1={0} x2={width} y1={0} y2={0} dashed={tick !== 0} />
        </Tick>
      ))}

      <g transform={translate(width / 2, height + 40)}>
        <XAxisDescription>{xAxisLabel}</XAxisDescription>
      </g>
    </g>
  );
};

export default Grid;
